// workflow.js
import { Audio } from "./audio.js";
import { Utils } from "./utils.js";
import { WorkflowProfiler } from "./profiler.js";
import { PerformanceMonitor } from "./performance.js";

export const Workflow = {
    _scrollThrottled: null,

    init() {
        Audio.register("statusChange", "/sounds/status-change.mp3");

        this._scrollThrottled = Utils.throttle(id => {
            Utils.scrollToElement(id);
            WorkflowProfiler.markScroll();
            PerformanceMonitor.markScroll();
        }, 300);
    },

    scrollToStep(stepId) {
        if (!this._scrollThrottled) {
            this._scrollThrottled = Utils.throttle(id => {
                Utils.scrollToElement(id);
                WorkflowProfiler.markScroll();
                PerformanceMonitor.markScroll();
            }, 300);
        }
        this._scrollThrottled(stepId);
    },

    playStatusSound() {
        Audio.play("statusChange");
    },

    bindLiveHandler(dotNetRef) {
        import("./events.js").then(({ Events }) => {
            Events.on("workflow:liveUpdated", data => {
                dotNetRef.invokeMethodAsync("OnWorkflowLiveUpdated", data)
                    .then(() => {
                        PerformanceMonitor.markUiUpdated();
                        WorkflowProfiler.markUpdate();
                    });
            });
        });
    }
};
